import { useEffect, useState } from 'react'
import TopService, { DTOP_TopData } from '../services/top-service'

const default_state: DTOP_TopData = {
  userdata: null,
  toplist: [],
  message: '',
  error: false,
}
export default function useTopUserInfo() {
  const [response, setResponse] = useState(default_state)

  useEffect(() => {
    let active = true
    TopService.getTop().then((response: DTOP_TopData) => {
      if (!active) {
        return
      }
      setResponse(response)
    })
    return () => {
      active = false
    }
  }, [])

  return response
}
